var map = {
	"./IMG_1267.JPG": 4280,
	"./IMG_1268.JPG": 2434,
	"./IMG_1269.JPG": 2089,
	"./IMG_1270.JPG": 1535,
	"./IMG_1271 2.JPG": 8939,
	"./IMG_1271.JPG": 3808,
	"./IMG_1272.JPG": 6061,
	"./IMG_1273.JPG": 3304,
	"./IMG_1274.JPG": 437,
	"./IMG_1275.JPG": 5354,
	"./IMG_1276.JPG": 5113,
	"./IMG_1277.JPG": 1046
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1879;